import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Menu from '@/components/Menu'

/** 销售订单 **/
import Sell from '@/components/home/Sell'
import Selladd from '@/components/home/Selladd'  //新增销售订单
import Selledit from '@/components/home/Selledit'  //编辑销售订单
import Sellorder from '@/components/home/Sellorder'  //销售单
import Allot from '@/components/home/Allot'  //商品调拨
import Allotadd from '@/components/home/Allotadd'  //新增商品调拨
import Refund from '@/components/home/Refund'  //商品退货
import Refundadd from '@/components/home/Refundadd'  //新增退货订单
import Refundedit from '@/components/home/Refundedit'  //编辑退货订单
import Pdorder from '@/components/home/Pdorder' //业务员下单
import Makeinventory from '@/components/home/Makeinventory' //库存盘点
import Makeinventoryadd from '@/components/home/Makeinventoryadd' //新增库存盘点
import yborder from '@/components/home/yborder' //有贝订单
import sellshippingbirld from '@/components/home/sellshippingbirld' //快递鸟快递单管理
import checkshippings from '@/components/home/checkshippings' //查询快递信息
import sellprinter from '@/components/home/print/printer' //快递鸟快递单管理
import sellprint from '@/components/home/print/sellprint' //二次分拣

//采购管理
import Storage from '@/components/purchase/Storage'  //进货入库
import Storageadd from '@/components/purchase/Storageadd'  //新增进货入库
import Storageedit from '@/components/purchase/Storageedit'  //编辑进货入库
import Purcharorder from '@/components/purchase/order'  //采购单
import Purcharorderkingdee from '@/components/purchase/orderkingdee'  //采购单金蝶版
import Purcharorderadd from '@/components/purchase/orderadd' //新增采购单
import Purcharorderedit from '@/components/purchase/orderedit' //编辑采购单
import Purcharrefund from '@/components/purchase/Purcharrefund' //采购商品退货


//线上商城管理
import Goods from '@/components/mall/Goods'
//import Goodspush from '@/components/mall/Goodspush' //发布商品
import Goodspush from '@/components/mall/Goodspushnew' //发布商品
import Goodspushinfo from '@/components/mall/Goodspushinfonew' //发布商品详情

import Goodsspecial from '@/components/mall/Goodsspecial' //商品专区管理
import Order from '@/components/mall/Order' //订单列表
import Orderedit from '@/components/mall/Orderedit' //订单修改
import OrderVerify from '@/components/mall/Orderverify' //特批单审核
import Combination from '@/components/mall/Combination' //组合管理
import CombinationEdit from '@/components/mall/CombinationEdit' //组合管理新增/编辑
import Offers from '@/components/mall/Offers' //营销活动
import Offersactiveadd from '@/components/mall/Offersactiveadd' //新增促销活动
import Offersactiveedit from '@/components/mall/Offersactiveedit' //编辑促销活动
import Offersnew from '@/components/mall/Offersnew' //新人专区活动
import Offerschange from '@/components/mall/Offerschange' //换购专区活动
import Offersspecial1 from '@/components/mall/Offersspecial1' //热卖专区活动1
import Offersspecial2 from '@/components/mall/Offersspecial2' //热卖专区活动2
import Offerscut from '@/components/mall/Offerscut' //秒杀专区活动
import Offerspintuan from '@/components/mall/Offerspintuan' //拼团专区活动
import Offersinvitation from '@/components/mall/Offersinvitation' //邀请有理活动管理
import Offersinvitationlog from '@/components/mall/Offersinvitationlog' //邀请有理活动邀请记录（邀请人任务）
import Offersinvitateelog from '@/components/mall/Offersinvitateelog' //邀请有理活动邀请记录（被邀请人任务）
import Sysoffers from '@/components/mall/Sysoffers' //平台营销活动
import Sysoffersjoin from '@/components/mall/Sysoffersjoin' //报名参加平台营销活动
import Paysetting from '@/components/mall/Paysetting' //支付配置
import Paysettingxiaoye from '@/components/mall/Paysettingxiaoye' //小也支付管理
import Shippingarea from '@/components/mall/Shippingarea'
//import Shippingarea1 from '@/components/mall/Shippingarea1'
import Shippingarea1 from '@/components/mall/shippingtemp/Shippingtempnews1' //运费模板
import Labelsetting from '@/components/mall/Labelsetting'
import Labelandcatid from '@/components/mall/Labelandcatid'
import Shippingtemp from '@/components/mall/Shippingtemp' //运费模板
import Shippingweight from '@/components/mall/Shippingweight' //运费重量
import Freetemp from '@/components/mall/Freetemp' //免邮模板
import Brandtemp from '@/components/mall/Brandtemp' //品牌模板
import Balancetemp from '@/components/mall/Balancetemp' //预存款模板
import Coupon from '@/components/mall/Coupon' //优惠券
import Coupondetail from '@/components/mall/Coupondetail' //优惠券
import Ad from '@/components/mall/Ad'
import Adadd from '@/components/mall/Adadd' //添加广告
import Adedit from '@/components/mall/Adedit' //添加广告
import Splitorder from '@/components/mall/Splitorder' //分销订单管理
import Draws from '@/components/mall/Draws' //抽奖管理
import Drawsadd from '@/components/mall/Drawsadd' //新增抽奖管理
import Drawsedit from '@/components/mall/Drawsedit' //编辑抽奖管理
import Award from '@/components/mall/award' //中奖纪录管理
import Packetfund from '@/components/mall/packetfund' //中奖红包提现流水
import Exportsyndata from '@/components/mall/exportsyndata' //导出数据同步记录
import Mallsalechart from '@/components/mall/mallsalechart' //线上销售数据看板
import Mallwallet from '@/components/mall/mallwallet' //我的钱包
import OrderAfter from '@/components/mall/OrderAfter' //售后订单

import SysGoodsinventory from '@/components/mall/SysGoodsinventory' //批量同步商品库存信息


import Mallsalesshop from '@/components/mall/mallsalesshop' //店铺销售统计
import Mallsalesshopdetail from '@/components/mall/mallsalesshopdetail' //店铺销售统计
import Mallsalesuser from '@/components/mall/mallsalesuser' //店铺会员销售统计
import Mallsalesuserdetail from '@/components/mall/mallsalesuserdetail' //店铺会员销售统计
import Mallsalesreplacedetail from '@/components/mall/mallsalesreplacedetail' //一件代发商品销售统计
import Showfrozen from '@/components/inventory/frozen' //展示冻结库存
import Showsalefulture from '@/components/inventory/showsalefulture' //展示库存预售情况
import Shippings from '@/components/mall/shipping/shippings' //快递模块


//天猫模块
import TMallSettings from '@/components/tmall/TMallSettings' //天猫店铺配置
import TMallGoods from '@/components/tmall/TMallGoods' //天猫商品管理
import TMallOrders from '@/components/tmall/TMallOrders' //天猫订单管理


//抖店模块
import DoudianSettings from '@/components/doudian/DoudianSettings' //抖店店铺配置
import DoudianGoods from '@/components/doudian/DoudianGoods' //抖店商品管理
import DoudianOrders from '@/components/doudian/DoudianOrders' //抖店订单管理


//拼多多模块
import PinddSettings from '@/components/Pindd/PinddSettings' //拼多多模块配置
import Pinddmatch from '@/components/Pindd/Pinddmatch' //拼多多商品匹配模块
import Pinddorder from '@/components/Pindd/Pinddorder' //拼多多订单管理


//数据统计
import StatOrder from '@/components/stat/Order'
import StatTardyGoods from '@/components/stat/Tardy'
import StatProduct from '@/components/stat/Product'
import StatCustomer from '@/components/stat/Customerstat'
import StatFund from '@/components/stat/Fund'
import StatCollection from '@/components/stat/Collection'
import StatAccount from '@/components/stat/Account'
import StatStorage from '@/components/stat/Storage'
import StatReport from '@/components/stat/Report'
import StatGetaccount from '@/components/stat/Accountstat'
import StatPayaccount from '@/components/stat/Paystat'
import StatSale from '@/components/stat/StatSale'
import StatSaletoCustomer from '@/components/stat/StatSaletoCustomer'
import Managestate from '@/components/stat/Managestate'
import Statdatashow from '@/components/stat/statdatashow' //线下销售数据看板
import Managestatefund from '@/components/stat/Managestatefund'
import Profitreport from '@/components/stat/Profitreport'
import Debt from '@/components/stat/Debt'
import StatSellandStorage from '@/components/stat/StatSellandStorage'
import StatmallSale from '@/components/stat/StatmallSale'
import mallsellstats from '@/components/stat/mallsellstats'
import mallselldetail from '@/components/stat/mallselldetail'
import malldaystats from '@/components/stat/malldaystats'
import managementOfInvoices from '@/components/stat/managementOfInvoices'

//店铺管理
import ShopLists from '@/components/shop/Lists'
import ShopStat from '@/components/shop/stat'

//报表统计
import Customervisit from '@/components/report/Customervisit' //客户拜访统计


/** 信息管理 **/
import Customer from '@/components/base/Customer'
import Customeradd from '@/components/base/Customeradd' //新增客户信息
import Customermoreadd from '@/components/base/Customermoreadd' //新增客户信息
import Customeredit from '@/components/base/Customeredit' //新增客户信息
import Customercate from '@/components/base/Customercate' //客户分类管理
import Customerdistrict from '@/components/base/Customerdistrict' //客户区域管理
import Customerdeposit from '@/components/base/Customerdeposit' //客户预存款充值
import Customerlevel from '@/components/base/Customerlevel' //客户等级管理
import ApplyCollection from '@/components/base/ApplyCollection' //供应商账本

import Percent from '@/components/base/Percent'
import Percentadd from '@/components/base/Percentadd' //新增提成设置
import Percentedit from '@/components/base/Percentedit' //编辑提成设置
import Clerk from '@/components/base/Clerk'
import Clerkadd from '@/components/base/Clerkadd' //新增职员
import Clerkedit from '@/components/base/Clerkedit' //编辑职员
import Clerkgroup from '@/components/base/Clerkgroup' //职员组别管理
import Clerkrun from '@/components/base/Clerkrun' //职员跑店记录
import Clerkcustomer from '@/components/base/Clerkcustomer' //职员负责的销售员信息
import Account from '@/components/base/Account'
import Accountadd from '@/components/base/Accountadd' //添加账户
import Accountedit from '@/components/base/Accountedit' //编辑账户
import Express from '@/components/base/Express' //快递管理

//库存记录
import Lists from '@/components/inventory/Lists'
import JDProduct from '@/components/inventory/JDProduct'
import Product from '@/components/inventory/Product'
import Productadd from '@/components/inventory/Productadd' //新增商品信息
import Productaddmore from '@/components/inventory/Productaddmore' //批量新增商品信息
import Productbrand from '@/components/inventory/Productbrand' //商品品牌管理
import Productcate from '@/components/inventory/Productcate' //商品分类管理
import Productsupply from '@/components/inventory/Productsupply' //商品供应商管理
import iSell from '@/components/inventory/Sell'
import iStorage from '@/components/inventory/Storage'
import Warehouse from '@/components/inventory/Warehouse'
import StorageLocation from '@/components/inventory/StorageLocation'
import Warehouseadd from '@/components/inventory/Warehouseadd'
import Warehouseedit from '@/components/inventory/Warehouseedit'
import ShelfLifeWarning from '@/components/inventory/ShelfLifeWarning'
import Warespace from '@/components/inventory/Warespace'
import Jdinventorycheck from '@/components/inventory/Jdinventorycheck'
import Splitagent from '@/components/inventory/Splitagent'
import CostAccount from '@/components/inventory/CostAccount'
import BrandCostAccount from '@/components/inventory/BrandCostAccount'
import CustomerCostAccount from '@/components/inventory/CustomerCostAccount'
import ClerkCostAccount from '@/components/inventory/ClerkCostAccount'

//系统设置
import Manager from '@/components/config/Manager'
import Managercate from '@/components/config/Managercate'
import Password from '@/components/config/Password'
import Print from '@/components/config/Print'
import Setting from '@/components/config/Setting'
import Sysreset from '@/components/config/Sysreset'

//金蝶系统数据对接
import KDcompy from '@/components/kingdee/KDcompy' //公司组织管理
import KDcustomer from '@/components/kingdee/KDcustomer' //公司组织客户管理
import KDseller from '@/components/kingdee/KDseller' //公司组织销售员管理
import KDgoods from '@/components/kingdee/KDgoods' //公司组织物料管理
import KDapply from '@/components/kingdee/KDapply' //公司组织供应商管理


//金蝶管易云数据对接
import Yungoods from '@/components/kingdeeyun/Yungoods' //金蝶云商品
import Yuncustomers from '@/components/kingdeeyun/Yuncustomers' //金蝶云客户
import Yunclerks from '@/components/kingdeeyun/Yunclerks' //金蝶云销售员


Vue.use(Router)

export default new Router({
  //mode:'history',
  routes: [
      /** 登录 **/
      {
    	  path: '/login',
    	  component: Login
      },
      
      /** 主页菜单 **/
      {
    	  path: '/',
    	  component: Menu,
    	  redirect: '/menu',
      },
      
      /** 菜单列表 **/
      {
    	  path: '/menu',
    	  component: Menu,
    	  redirect: '/home/sell',
    	  children: [
    	             
    	      /** 订单管理菜单 **/
    	      {path: '/home/sell',component: Sell}, //销售订单
    	      
    	      {path: '/home/selledit',component: Selledit}, //编辑销售订单
    	      
    	      {path: '/home/storage',component: Storage}, //进货入库
    	      {path: '/home/storageadd',component: Storageadd}, //新增进货入库
    	      {path: '/home/storageedit',component: Storageedit}, //新增进货入库
    	      {path: '/home/allot',component: Allot}, //商品调拨
    	      {path: '/home/allotadd',component: Allotadd}, //新增商品调拨
    	      {path: '/home/refund',component: Refund}, //商品退款
    	      {path: '/home/refundadd',component: Refundadd}, //新增退货订单
    	      {path: '/home/refundedit',component: Refundedit}, //编辑退货订单
    	      {path: '/home/sellorder',component: Sellorder}, //销售单
    	      {path: '/home/makeinventory',component: Makeinventory}, //库存盘点
    	      {path: '/home/makeinventoryadd',component: Makeinventoryadd}, //新增库存盘点
              {path: '/home/pdorder',component: Pdorder}, //业务员下单
              {path: '/home/yborder',component:yborder}, //有贝订单
              {path: '/home/sellshippingbirld',component:sellshippingbirld}, //快递鸟销售单管理
              {path: '/home/checkshippings',component:checkshippings}, //检查快递信息
              {path: '/home/sellprinter',component:sellprinter},  //快速打印电子面单
              {path: '/home/sellprint',component:sellprint},  //二次分拣
    	      
    	      /** 采购管理 **/
              {path: '/purchase/order',component: Purcharorder}, //采购单
              {path: '/purchase/orderkingdee',component: Purcharorderkingdee}, //采购单金蝶版
    	      {path: '/purchase/orderadd',component: Purcharorderadd}, //新增采购单
    	      {path: '/purchase/orderedit',component: Purcharorderedit}, //编辑采购单
    	      {path: '/purchase/storage',component: Storage}, //进货入库单
    	      {path: '/purchase/purcharrefund',component: Purcharrefund}, //采购单退货

    	      
    	      /** 线上商城管理 **/
    	      {path: '/mall/goods',component: Goods}, //在售商品
              {path: '/mall/goodspush',component: Goodspush}, //商品信息发布
              {path: '/mall/goodspushinfo',component: Goodspushinfo}, //商品信息发布详情 
    	      {path: '/mall/goodsspecial',component: Goodsspecial}, //商品专区管理
              {path: '/mall/order',	component: Order}, //订单管理
              {path: '/mall/orderedit',	component: Orderedit}, //订单修改
              {path: '/mall/orderverify', component: OrderVerify}, //特批单审核
              {path: '/mall/combination', component: Combination}, //组合管理
              {path: '/mall/combinationEdit', component: CombinationEdit}, //新增/编辑组合管理
              {path: '/mall/offers',component: Offers}, //促销活动
              {path: '/mall/offersactiveadd',component: Offersactiveadd}, //新增促销活动
              {path: '/mall/offersactiveedit',component: Offersactiveedit}, //编辑促销活动
              {path: '/mall/offersnew',component: Offersnew}, //新人专区活动
              {path: '/mall/offerschange',component: Offerschange}, //换购专区活动
              {path: '/mall/offersspecial1',component: Offersspecial1}, //热卖专区活动1
              {path: '/mall/offersspecial2',component: Offersspecial2}, //热卖专区活动2
              {path: '/mall/offerscut',component: Offerscut}, //秒杀专区活动
              {path: '/mall/Offerspintuan',component: Offerspintuan}, //拼团专区活动
              {path: '/mall/Offersinvitation',component: Offersinvitation}, //邀请有礼活动管理
              {path: '/mall/Offersinvitationlog',component: Offersinvitationlog}, //邀请有礼活动邀请记录管理（邀请人）
              {path: '/mall/Offersinvitateelog',component: Offersinvitateelog}, //邀请有礼活动邀请记录管理（被邀请人）
              {path: '/mall/Sysoffers',component: Sysoffers}, //平台营销活动
              {path: '/mall/Sysoffersjoin',component: Sysoffersjoin}, //报名参加平台营销活动
              {path: '/mall/mallwallet',component: Mallwallet}, //我的钱包
              
              {path: '/mall/shipping/shippings',component: Shippings}, //快递模板信息
              {path: '/mall/shipping/OrderAfter',component: OrderAfter}, //售后订单
              {path: '/mall/mall/SysGoodsinventory',component: SysGoodsinventory}, //批量同步商品库存信息

              {path: '/mall/paysettingxiaoye',component: Paysettingxiaoye}, //小也在线支付设置
              {path: '/mall/paysetting',component: Paysetting}, //在线支付
              {path: '/mall/shippingarea',component: Shippingarea}, //配送区域
              {path: '/mall/shippingtemp/shippingtempnews1',component: Shippingarea1}, //配送区域1
              {path: '/mall/labelsetting',component: Labelsetting}, //标签设置
              {path: '/mall/labelandcatid',component: Labelandcatid}, //标签商品分类管理
              {path: '/mall/shippingtemp',component: Shippingtemp}, //邮费模板
              {path: '/mall/Shippingweight',component: Shippingweight}, //模板重量管理
              {path: '/mall/freetemp',component: Freetemp}, //免邮模板
              {path: '/mall/Brandtemp',component: Brandtemp}, //品牌模板
              {path: '/mall/balancetemp',component: Balancetemp}, //预存款模板
              {path: '/mall/Coupon',component: Coupon}, //优惠券管理
              {path: '/mall/Coupondetail',component: Coupondetail}, //优惠券详情
              {path: '/mall/ad',component: Ad}, //广告管理
              {path: '/mall/adadd',component: Adadd}, //添加广告
              {path: '/mall/adedit',component: Adedit}, //编辑广告
              {path: '/mall/splitorder',component: Splitorder}, //分销订单管理
              {path: '/mall/draws',component: Draws}, //抽奖管理
              {path: '/mall/drawsadd',component: Drawsadd}, //新增抽奖管理
              {path: '/mall/drawsedit',component: Drawsedit}, //编辑抽奖管理
              {path: '/mall/award',component: Award}, //编辑抽奖管理
              {path: '/mall/packetfund',component:Packetfund}, //中奖红包提现流水
              {path: '/mall/exportsyndata',component:Exportsyndata}, //导出数据同步记录
              {path: '/mall/mallsalechart',component:Mallsalechart}, //线上销售数据看版
              {path: '/mall/statdatashow',component:Statdatashow}, //线下销售数据看板
              {path: '/mall/mallsalesshop',component:Mallsalesshop}, //店铺销售统计
              {path: '/mall/mallsalesshopdetail',component:Mallsalesshopdetail}, //店铺销售统计
              {path: '/mall/mallsalesuser',component:Mallsalesuser}, //店铺会员销售统计
              {path: '/mall/mallsalesuserdetail',component:Mallsalesuserdetail}, //店铺会员销售统计
              {path: '/mall/mallsalesreplacedetail',component: Mallsalesreplacedetail}, //一件代发商品销售统计


              /** 天猫模板信息 **/
              {path: '/tmall/settings',component: TMallSettings}, //店铺配置
              {path: '/tmall/goods',component: TMallGoods}, //商品管理
              {path: '/tmall/orders',component: TMallOrders}, //订单管理
              

              /** 抖店模板信息 **/
              {path: '/doudian/settings',component: DoudianSettings}, //店铺配置
              {path: '/doudian/goods',component: DoudianGoods}, //商品管理
              {path: '/doudian/orders',component: DoudianOrders}, //订单管理


              /** 拼多多模块信息 **/
              {path: '/Pindd/PinddSettings',component: PinddSettings}, //拼多多设置
              {path: '/Pindd/Pinddmatch',component: Pinddmatch}, //商品匹配模块
              {path: '/Pindd/Pinddorder',component: Pinddorder}, //订单管理

              
              /** 统计查询 **/
              {path: '/stat/order',component: StatOrder}, //销售订单
              {path: '/stat/tardy',component: StatTardyGoods}, //欠货商品
              {path: '/stat/product',component: StatProduct}, //销售统计
              {path: '/stat/customerstat',component: StatCustomer}, //出库记录
              {path: '/stat/fund',component: StatFund}, //收入流水
              {path: '/stat/collection',component: StatCollection}, //应收账款
              {path: '/stat/account',component: StatAccount}, //未付款订单
              {path: '/stat/storage',component: StatStorage}, //未付款进货单
              {path: '/stat/report',component: StatReport}, //统计报表
              {path: '/stat/accountstat',component: StatGetaccount}, //往来收款统计
              {path: '/stat/paystat',component: StatPayaccount}, //往来付款统计
              {path: '/stat/statsale',component: StatSale}, //销售统计
              {path: '/stat/statsaletocustomer',component: StatSaletoCustomer}, //销售员成单客户数统计
              {path: '/stat/managestate',component: Managestate}, //经营状况
              {path: '/stat/managestatefund',component: Managestatefund}, //经营流水
              {path: '/stat/profitreport',component: Profitreport}, //利润报告
              {path: '/stat/debt',component: Debt}, //资产负债
              {path: '/stat/statsellandstorage',component: StatSellandStorage}, //进销存统计
              {path: '/stat/Statmallsale',component: StatmallSale}, //线上商城统计
              {path: '/stat/mallsellstats',component: mallsellstats}, //线上商城销售统计
              {path: '/stat/mallselldetail',component: mallselldetail}, //线上商城销售详情统计
              {path: '/stat/malldaystats',component: malldaystats}, //线上商城销售日结统计
              {path: '/stat/managementOfInvoices',component: managementOfInvoices}, //线上商城销售日结统计
              
              /** 店铺管理 **/
              {path: '/shop/lists',component: ShopLists}, //下属店铺
              {path: '/shop/stat',component: ShopStat}, //统计分析
              
              /** 统计报表 **/
              {path: '/report/customervisit',component:Customervisit}, //客户拜访统计 
              
              /** 信息管理 **/
              {path: '/base/customer',component: Customer}, //客户管理
              {path: '/base/customeradd',component: Customeradd}, //添加客户客户  
              {path: '/base/customermoreadd',component: Customermoreadd}, //批量新增客户
              {path: '/base/customeredit',component: Customeredit}, //编辑客户
              {path: '/base/customercate',component: Customercate}, //客户分类管理
              {path: '/base/customerdistrict',component: Customerdistrict}, //客户区域管理
              {path: '/base/customerdeposit',component: Customerdeposit}, //客户区预存款充值
              {path: '/base/customerlevel',component: Customerlevel}, //客户等级管理
              {path: '/base/applycollection',component: ApplyCollection}, //供应商账本
              
              {path: '/base/clerk',component: Clerk}, //职员管理
              {path: '/base/clerkadd',component: Clerkadd}, //新增职员
              {path: '/base/clerkedit',component: Clerkedit}, //编辑职员
              {path: '/base/clerkgroup',component: Clerkgroup}, //编辑组别
              {path: '/base/clerkrun',component: Clerkrun}, //跑店记录
              {path: '/base/clerkcustomer',component: Clerkcustomer}, //业务员负责的客户信息
              {path: '/base/account',component: Account}, //银行账号管理
              {path: '/base/accountadd',component: Accountadd}, //添加银行账号
              {path: '/base/accountedit',component: Accountedit}, //编辑银行账号
              {path: '/base/percent',component: Percent}, //提成管理
              {path: '/base/percentadd',component: Percentadd}, //新增提成设置
              {path: '/base/percentedit',component: Percentedit}, //编辑提成设置
              {path: '/base/express',component: Express}, //快递管理
              
              /** 库存记录 **/
              {path: '/inventory/lists',component: Lists}, //库存管理
              {path: '/inventory/jdproduct',component: JDProduct}, //京东商品管理
              {path: '/inventory/product',component: Product}, //商品管理
              {path: '/inventory/productadd',component: Productadd}, //新增商品信息
              {path: '/inventory/productaddmore',component: Productaddmore}, //批量新增商品信息
              {path: '/inventory/productbrand',component: Productbrand}, //商品品牌管理
              {path: '/inventory/productcate',component: Productcate}, //商品分类管理
              {path: '/inventory/productsupply',component: Productsupply}, //商品供应商管理
              {path: '/inventory/sell',component: iSell}, //出库记录
              {path: '/inventory/storage',component: iStorage}, //入库记录
              {path: '/inventory/warehouse',component: Warehouse}, //仓库管理
              {path: '/inventory/shelfLifeWarning',component: ShelfLifeWarning}, //保质期预警查询
              {path: '/inventory/StorageLocation',component: StorageLocation}, //货位管理
              {path: '/inventory/warehouseadd',component: Warehouseadd}, //新增仓库
              {path: '/inventory/warehouseedit',component: Warehouseedit}, //编辑仓库
              {path: '/inventory/warespace',component: Warespace}, //仓位管理
              {path: '/inventory/jdinventorycheck',component: Jdinventorycheck}, //京东商品库存查询
              {path: '/inventory/splitagent',component: Splitagent}, //我的合作代理商
              {path: '/inventory/frozen',component: Showfrozen}, //展示商品冻结库存出处
              {path: '/inventory/showsalefulture',component: Showsalefulture}, //展示库存商品预售情况
              {path: '/inventory/costaccount',component: CostAccount}, //商品成本核算查询
              {path: '/inventory/BrandCostAccount',component: BrandCostAccount}, //品牌成本核算查询
              {path: '/inventory/CustomerCostAccount',component: CustomerCostAccount},  //客户成本核算查询
              {path: '/inventory/ClerkCostAccount',component: ClerkCostAccount}, //销售员成本核算查询

              
              /** 系统设置 **/
              {path: '/config/password',component: Password}, //修改密码
              {path: '/config/manager',component: Manager}, //用户管理
              {path: '/config/managercate',component: Managercate}, //用户管理
              {path: '/config/print',component: Print}, //打印设置
              {path: '/config/setting',component: Setting}, //打印设置
              {path: '/config/sysreset',component: Sysreset}, //系统重建

              /** 金蝶系统对接数据管理 **/
              {path: '/kingdee/kdcompy',component: KDcompy}, //公司组织管理
              {path: '/kingdee/kdcustomer',component: KDcustomer}, //公司组织客户管理
              {path: '/kingdee/kdseller',component: KDseller}, //公司组织销售员管理
              {path: '/kingdee/kdgoods',component: KDgoods}, //公司组织物料管理
              {path: '/kingdee/kdapplys',component: KDapply}, //公司组织供应商管理

              /** 金蝶管易云系统对接数据管理 **/
              {path: '/kingdeeyun/Yungoods',component: Yungoods}, //金蝶云商品
              {path: '/kingdeeyun/Yuncustomers',component: Yuncustomers}, //金蝶云客户
              {path: '/kingdeeyun/Yunclerks',component: Yunclerks}, //金蝶云销售员

              

    	      
          ]
      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js